export enum WebsocketEventsEnum {
  CONNECT = 'connect',
  DISCONNECT = 'disconnect',
  ERROR = 'error',
  RECONNECT = 'reconnect',
  CONNECT_ERROR = 'connect_error',
}
